module.exports = __webpack_public_path__ + "img/pic-头像@2x.d3acdc8e.jpg";